import React from "react";

import { makeStyles, Paper, Typography } from "@material-ui/core";
import classNames from "classnames";

interface IProps {
  step: string;
  enabled?: boolean;
}

const useStyles = makeStyles((theme) => ({
  number: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    borderRadius: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
  },
  numberDisabled: {
    backgroundColor: theme.palette.secondary.light,
  },
  numberContent: {
    fontWeight: "bold",
    color: '#FFF'
  },
  numberContentDisabled: {
    color: theme.palette.secondary.dark,
  },
}));

const StepNumber: React.FC<IProps> = ({ step, enabled = true }) => {
  const classes = useStyles();

  return (
    <Paper
      color="primary"
      className={classNames(classes.number, { [classes.numberDisabled]: !enabled })}
      elevation={3}
    >
      <Typography
        variant="body1"
        className={classNames(classes.numberContent, { [classes.numberContentDisabled]: !enabled })}
      >
        {step}
      </Typography>
    </Paper>
  );
};

export default StepNumber;
